import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-add-new-epp',
  templateUrl: './add-new-epp.component.html',
  styleUrls: ['./add-new-epp.component.scss']
})
export class AddNewEppComponent implements OnInit {

  breadCrumbItems: Array<{}>;
  EPPNew: FormGroup;
  submitted = false;
  isLoading: boolean;
  currentUser: any;
  baseDocType:any;
  UserID: any;
  constructor(  private fb: FormBuilder,
    private gs: GeneralService,
    private router: Router) { 
      let a = this.router.getCurrentNavigation().extras
      if(a){
        if(a.state){
          this.UserID = a.state.Uid
          console.log("userid",this.UserID)
          localStorage.setItem('id',this.UserID)
        }
      }
      if(localStorage.getItem('id')){
        this.UserID = localStorage.getItem('id')
      }
      this.breadCrumbItems = [
        { label: "EPP List", path: "/users/view-epp" },
        { label: "Add New EPP", path: "/", active: true },
      ];
    }

  ngOnInit() {
    this.currentUser = this.gs.getcurrentUser()
    this.EPPNew = this.fb.group({
      district: new FormControl('', Validators.required),
      taluka: new FormControl(''),
      village: new FormControl(''),
      StateID: new FormControl(7),
      survey_number: new FormControl('', Validators.required),
      start_date: new FormControl('', Validators.required),
      end_date: new FormControl('', Validators.required),
      Admin_ID: new FormControl(this.currentUser.Id),
      user_id: new FormControl(this.UserID),
      BaseDocument: new FormControl(null, Validators.required),
      citysurveyoffice: new FormControl(''),
      ward: new FormControl(''),
      sheetno: new FormControl(''),
      EPP_In_Days: new FormControl(30, [Validators.min(0),Validators.max(30),Validators.required]),
    })
  }
  onChangeBaseDocType() {
    this.baseDocType = this.EPPNew.controls.BaseDocument.value;
    if(this.baseDocType === '0') {
      this.EPPNew.get('taluka').setValidators([Validators.required]);
      this.EPPNew.get('village').setValidators([Validators.required]);
      this.EPPNew.get('citysurveyoffice').clearValidators();
      this.EPPNew.get('ward').clearValidators();
      this.EPPNew.get('sheetno').clearValidators();
      this.EPPNew.get('taluka').updateValueAndValidity();  
      this.EPPNew.get('village').updateValueAndValidity();  
      this.EPPNew.get('citysurveyoffice').updateValueAndValidity();  
      this.EPPNew.get('ward').updateValueAndValidity();  
      this.EPPNew.get('sheetno').updateValueAndValidity();  
    } else if(this.baseDocType === '1') {
      this.EPPNew.get('citysurveyoffice').setValidators([Validators.required]);
      this.EPPNew.get('ward').setValidators([Validators.required]);
      this.EPPNew.get('sheetno').setValidators([Validators.required]);
      this.EPPNew.get('taluka').clearValidators();
      this.EPPNew.get('village').clearValidators();
      this.EPPNew.get('citysurveyoffice').updateValueAndValidity();  
      this.EPPNew.get('ward').updateValueAndValidity();  
      this.EPPNew.get('sheetno').updateValueAndValidity();  
      this.EPPNew.get('taluka').updateValueAndValidity();  
      this.EPPNew.get('village').updateValueAndValidity();  
    }    
  }
  onSubmit() {
    if(this.baseDocType === '1' && this.EPPNew.valid) {
      this.EPPNew.controls.citysurveyoffice.setValue(this.EPPNew.controls.citysurveyoffice.value.trim());
      this.EPPNew.controls.ward.setValue(this.EPPNew.controls.ward.value.trim());
      this.EPPNew.controls.sheetno.setValue(this.EPPNew.controls.sheetno.value.trim());
    } else if(this.baseDocType === '0' && this.EPPNew.valid){
      this.EPPNew.controls.taluka.setValue(this.EPPNew.controls.taluka.value.trim());
      this.EPPNew.controls.village.setValue(this.EPPNew.controls.village.value.trim());
      
    }
    this.EPPNew.controls.district.setValue(this.EPPNew.controls.district.value.trim());
    this.EPPNew.controls.survey_number.setValue(this.EPPNew.controls.survey_number.value.trim());
    this.submitted = true;
    console.log("EPP form",this.EPPNew.value)
    console.log("EPP form",this.EPPNew.controls)
    if (this.EPPNew.valid) {
      // 1 is Property ID
      this.isLoading = true;
      this.gs.addNewEpp(this.EPPNew.value).subscribe((res:any) => {
        this.isLoading = false;

        if(res.status === 400){
          Swal.fire({
            position: 'top-end',
            type: 'info',
            title: res.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.router.navigate(['users/view-epp'])
          this.isLoading = false;
        }else{
          Swal.fire({
            title: 'EPP Added',
            text: res.message,
            type: 'success',
          }).then(() => {
            this.submitted = false;
            // this.reFresh.emit();
            this.router.navigate(['/users/view-epp']);
          });
        }
      },(error) => {                              //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      });
    }
  }
  get f() {
    return this.EPPNew.controls;
  }
  SetEndDate() {
    var date = new Date(this.EPPNew.controls.start_date.value);
    this.EPPNew.controls.end_date.setValue(this.add_years(date, 1).toISOString().substr(0, 10));
  }

  add_years(dt,n) 
  {
    return new Date(dt.setFullYear(dt.getFullYear() + n));      
  }

}
